<template>
  <div style="padding: 20px;">
    <div style="display:flex;font-weight: bold;justify-content: space-between">
      <div v-for="(item ,index) in totalData" :key="index" style="" class="total">
        <div>{{item.name}}</div>
        <div style="display: flex;justify-content: space-around;margin-top: 20px;font-size: 13px">
          <div>
            <div style="font-size: 16px">{{item.count}}</div>
            <div>总单量</div>
          </div>
          <div>
            <div style="font-size: 16px">￥{{item.money}}</div>
            <div>总金额</div>
          </div>
        </div>
      </div>
    </div>
    <div class="line-chart">
      <div style="display: flex;padding: 10px 0 0 20px;align-items: center">
        <div style="margin-right: 10px">交易趋势</div>
        <el-select v-model="query.regionId" filterable placeholder="请选择" style="width: 140px" clearable @change="selectList">
          <el-option
              v-for="item in regionList"
              :key="item.regionId"
              :label="item.regionName"
              :value="item.regionId"
          />
        </el-select>
      </div>

      <div id="mainss" ref="lineColumnar" style="width: 100%;height: 100%"></div>

      <el-select v-model="query.regionId" placeholder="请选择" style="width: 140px" filterable clearable @change="selectList">
        <el-option
            v-for="item in regionList"
            :key="item.regionId"
            :label="item.regionName"
            :value="item.regionId"
        />
      </el-select>
      <el-table :data="tableData" style="width: 100%" border class="table" height="700px">
        <el-table-column prop="mchId" label="商户Id" width="180" align="left" />
        <el-table-column prop="mchName" label="商户名称" align="left"/>
        <el-table-column prop="limitMoney" label="限额" align="left"/>
        <el-table-column prop="regionName" label="所属公司" align="left"/>
        <el-table-column label="收据章">
          <template #default="scope">
            <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.receiptChapterUrl"
                :zoom-rate="1.2"
                :max-scale="7"
                :min-scale="0.2"
                :preview-src-list="[scope.row.receiptChapterUrl]"
                show-progress
                :initial-index="4"
                fit="cover"
            />
          </template>
        </el-table-column>
        <el-table-column label="合同章">
          <template #default="scope">
            <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.contractChapterImage"
                :zoom-rate="1.2"
                :max-scale="7"
                :min-scale="0.2"
                :preview-src-list="[scope.row.contractChapterImage]"
                show-progress
                :initial-index="4"
                fit="cover"
            />
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template #default="scope">{{scope.row.state}}</template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="120">
          <template #default="scope">
            <el-button link type="primary" size="small" @click="toDefault(scope.row)">详情</el-button>
            <el-button link type="primary" size="small" @click="updateDialog = true,updateItem = scope.row">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog v-model="updateDialog" title="更新" width="500">
      <div>
        <el-form :model="updateItem" :rules="updateRules" ref="updateRules" class="demo-form-inline">
          <el-form-item label="限额" prop="limitMoney">
            <el-input-number v-model="updateItem.limitMoney" :min="1" :max="10000000"/>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="updateDialog = false">取 消</el-button>
          <el-button type="primary" @click="update">确 定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {selectMerchant,updateMerchant,selectRegion} from "../../api/pay/merchant";
const echarts = require('echarts/lib/echarts');
require('echarts/lib/component/toolbox');
require('echarts/lib/component/tooltip');
require('echarts/lib/component/grid');
require('echarts/lib/component/legend');
require('echarts/lib/chart/bar');
require('echarts/lib/chart/line');
export default {
  name: "Merchant",
  data() {
    return {
      regionList:[],
      tableData:[],
      query:{

      },
      totalData:[{money:0, count:0, name:"日统计"},
        {money:0, count:0, name:"周统计"},
        {money:0, count:0, name:"月统计"}
      ],
      lineChartData:{
        day:[],
        money:[],
        count:[]
      },
      updateDialog:false,
      updateItem:{
        mchId:null,
        state:null,
        limitMoney:0
      },
      updateRules: {
        limitMoney: [{
          required: true,
          message: '请输入限额！',
          trigger: 'change'
        },],
      }
    }
  },
  methods:{
    toDefault(val){
      this.$router.push({
        path: "/sonMerchant",
        query: {
          item: JSON.stringify(val)
        }
      })
    },
    updateState(val){
      updateMerchant(val).then(val=>{
        if (val.code === 200) {
          this.selectList();
          this.updateDialog = false;
          this.$message.success("更新成功！");
        } else {
          this.$message.error("更新失败！");
        }
      })
    },
    selectList(){
      selectMerchant(this.query).then(val=>{
        if (val.code === 200){
          this.tableData = val.data.vo;
          this.totalData[0].money = val.data.summaryVO.paydayMoney/100;
          this.totalData[0].count = val.data.summaryVO.paydayCount;
          this.totalData[1].money = val.data.summaryVO.payWeekMoney/100;
          this.totalData[1].count = val.data.summaryVO.payWeekCount;
          this.totalData[2].money = val.data.summaryVO.payMoney/100;
          this.totalData[2].count = val.data.summaryVO.payCount;
          this.lineChartData.day = val.data.summaryVO.list.map(item => item.day);
          this.lineChartData.money = val.data.summaryVO.list.map(item => item.payMoney);
          this.lineChartData.count = val.data.summaryVO.list.map(item => item.payCount);
          this.setOption();
        }
      })
    },
    update(){
      this.$refs['updateRules'].validate((valid) => {
        console.log(valid)
        if (valid) {
          updateMerchant(this.updateItem).then(val=>{
            if (val.code === 200) {
              this.selectList();
              this.updateDialog = false;
              this.$message.success("更新成功！");
            } else {
              this.$message.error("更新失败！");
            }
          })
        }
      })

    },
    setOption() {
      const money = this.lineChartData.money.map(value => value / 100);
      const maxValue = Math.max(...money);
      const interval = Math.ceil(maxValue / 8); // 分成8个左右的刻度
      let myChart = echarts.init(this.$refs.lineColumnar);
      myChart.off('click')
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        legend: {
          data: ['金额', '单量']
        },
        xAxis: [
          {
            type: 'category',
            data: this.lineChartData.day,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            // 单量轴自动计算最大值（避免硬编码）
            max: 'dataMax',
            interval: 50,
            axisLabel: {
              formatter: '{value}单'
            }
          },
          {
            type: 'value',
            min: 0,
            // 金额轴自动计算最大值（关键修复）
            max: 'dataMax',
            // 自动计算间隔（避免硬编码5）
            interval: interval,
            axisLabel: {
              formatter: '{value}￥'
            }
          }
        ],
        series: [
          {
            name: '单量',
            type: 'bar',
            label: {
              show: true,
              position: 'top',
              formatter: params => (params.value )+ '单',
              // 标签不重叠策略
              avoidLabelOverlap: true,
              // 隔一个显示一个（根据数据密度调整）
              interval: 'auto'
            },
            tooltip: {
              valueFormatter: function (value) {
                return value + '单';
              }
            },

            data: this.lineChartData.count
          },
          {
            name: '金额',
            type: 'line',
            yAxisIndex: 1,
            label: {
              show: true,
              position: 'top',
              formatter: params => params.value+ '元',
              // 标签不重叠策略
              avoidLabelOverlap: true,
              // 隔一个显示一个（根据数据密度调整）
              interval: 'auto'
            },
            tooltip: {
              valueFormatter: function (value) {
                return value + '￥';
              }
            },
            data: money
          }
        ]
      })
    }
  },
  created() {
    this.selectList();
    selectRegion().then(val=>{
      if (val.code === 200){
        this.regionList=val.data;
      }
      console.log(val)
    })
  }
}
</script>

<style scoped>
.table {
  width: 100%;
  font-size: 14px;
  text-align: left;
  border-radius: 12px;
  margin-top: 20px;
}
.total{
  text-align: center;
  width: 29%;
  padding:18px 20px 20px 20px;
  border-radius: 12px;
  box-shadow: 0px 1px 10px 1px #f5f5f5;
}
.line-chart{
  height: 400px;
  background-color: #FAFCFF;
  border-radius: 16px;
  margin: 20px 0;
}
</style>
<style type="less">
/* CJL TEST
1.重写plus的image图片预览大图的的position定位样式为static !important;
2.需在el-table中手动添加要覆盖的class名 如el-table__cell
3.此css代码需放在全局的less的style节点中 */
.el-table__cell {
  position: static !important;
}
</style>